module.exports = "/fonts/nucleo-icons.svg?ae42fa524981a56f3f289447cff36eb1";